import { render, staticRenderFns } from "./setting-company-account-list.vue?vue&type=template&id=a0ad29bc&"
import script from "./setting-company-account-list.vue?vue&type=script&lang=js&"
export * from "./setting-company-account-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports